import { Guid } from '@web/utils';

export class WarehouseRestockProduct {
  public constructor(
    private readonly data: {
      createdAt: Date;
      id: Guid;
      productId: Guid;
      productName: string;
      quantity: number;
    },
  ) {}

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get productId(): Guid {
    return this.data.productId;
  }

  public get productName(): string {
    return this.data.productName;
  }

  public get quantity(): number {
    return this.data.quantity;
  }
}
